import { render } from "./shareTrainingCampClockin.vue?vue&type=template&id=50a0d160&scoped=true"
import script from "./shareTrainingCampClockin.vue?vue&type=script&lang=js"
export * from "./shareTrainingCampClockin.vue?vue&type=script&lang=js"

import "./shareTrainingCampClockin.vue?vue&type=style&index=0&id=50a0d160&scoped=true&lang=css"

import exportComponent from "/Users/aiden/Desktop/hujian/hongyu/edu-web-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50a0d160"]])

export default __exports__